import styled from "styled-components";

const DashboardSearchWrapper = styled.div`
  max-width: 400px;
  width: 100%;
`;

export { DashboardSearchWrapper };
